export const Messages = {
  LoadingPrevContent: 'Loading previous content...',
  LoadingNextContent: 'Loading next content...',
  SearchingTMs: 'Searching translation memories...',
  SearchingInDocument: 'Searching in this document...',
  NoMatchesFound: 'No matches found',
} as const;
